import { Link, useLocation, useNavigate } from "react-router-dom";
import { removeCookie } from "JS/cookie";
import logo from "Image/markpickLogo.svg";
import { useState } from "react";
import EmailSendModal from "Pages/EmailSendModal";
import { FaBars, FaTimes } from "react-icons/fa";
import { useNewCount } from "Contexts/NewCountContext";

const NBadge = ({ show }) => {
  if (!show) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "16px",
        height: "16px",
        padding: "0 5px",
        marginLeft: "8px",
        borderRadius: "8px",
        backgroundColor: "#dc2626",
        color: "#ffffff",
        fontSize: "11px",
        fontWeight: "700",
        lineHeight: 1,
      }}
    >
      N
    </span>
  );
};

const SideBar = () => {
  const path = useLocation().pathname;
  const navigate = useNavigate();
  const [emailModal, setEmailModal] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { shouldShowBadge } = useNewCount();

  const toggleMobileMenu = () => {
    setIsMobileOpen((prev) => !prev);
  };

  const sidebarStyles = {
    mobileToggle: {
      position: 'fixed',
      top: '16px',
      left: '16px',
      zIndex: 1000,
      padding: '12px',
      backgroundColor: '#fff',
      border: '1px solid #ddd',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      display: 'none'
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 900,
      display: isMobileOpen ? 'block' : 'none'
    },
    sidebar: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      width: '260px',
      backgroundColor: '#ffffff',
      boxShadow: '4px 0 10px -2px rgba(0, 0, 0, 0.1)',
      borderRight: '1px solid #cbd5e1',
      zIndex: 950,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    },
    logoSection: {
      padding: '20px',
      borderBottom: '1px solid #cbd5e1',
      backgroundColor: '#f8fafc'
    },
    logo: {
      height: '32px',
      display: 'block'
    },
    menuContainer: {
      flex: 1,
      overflowY: 'auto',
      padding: '16px 0'
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 20px',
      color: '#1e293b',
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      cursor: 'pointer'
    },
    menuItemActive: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8',
      borderLeft: '4px solid #1d4ed8',
      fontWeight: '600'
    },
    sectionTitle: {
      padding: '12px 20px 8px 20px',
      fontSize: '13px',
      fontWeight: '700',
      color: '#4b5563',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      borderBottom: '2px solid #e5e7eb',
      marginBottom: '8px',
      marginLeft: '12px',
      marginRight: '12px',
      paddingBottom: '8px',
      background: 'rgb(241, 245, 249)',
      borderRadius: '4px 4px 0 0'
    },
    logoutSection: {
      padding: '16px',
      borderTop: '1px solid #cbd5e1',
      backgroundColor: '#f8fafc'
    },
    logoutBtn: {
      width: '100%',
      padding: '12px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#dc2626',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    }
  };

  // 수정된 반응형 CSS
  const responsiveStyles = `
    @media (max-width: 768px) {
      .mobile-toggle {
        display: block !important;
      }
      .sidebar-responsive {
        transform: ${isMobileOpen ? 'translateX(0)' : 'translateX(-100%)'} !important;
        transition: transform 0.3s ease-in-out !important;
      }
    }
    @media (min-width: 769px) {
      .mobile-toggle {
        display: none !important;
      }
      .sidebar-responsive {
        transform: translateX(0) !important;
        transition: none !important;
      }
      .mobile-overlay {
        display: none !important;
      }
    }
    .menu-item:hover {
      background-color: #f1f5f9;
      color: #0f172a;
    }
    .logout-btn:hover {
      background-color: #fef2f2;
    }
  `;

  return (
    <>
      <style>{responsiveStyles}</style>
      
      {/* 모바일 메뉴 토글 버튼 */}
      <button 
        className="mobile-toggle"
        style={sidebarStyles.mobileToggle}
        onClick={toggleMobileMenu}
      >
        {isMobileOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {/* 모바일 오버레이 */}
      <div 
        className="mobile-overlay"
        style={sidebarStyles.overlay}
        onClick={() => setIsMobileOpen(false)}
      />

      {/* 사이드바 */}
      <div 
        className="sidebar-responsive"
        style={sidebarStyles.sidebar}
      >
        {/* 로고 */}
        <div style={sidebarStyles.logoSection}>
          <Link to="/home">
            <img src={logo} alt="마크픽 로고" style={sidebarStyles.logo} />
          </Link>
        </div>

        {/* 메뉴 */}
        <div style={sidebarStyles.menuContainer}>
          {/* DASHBOARD */}
          <Link to="/home" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/home" ? sidebarStyles.menuItemActive : {})
              }}
            >
              DASHBOARD
            </div>
          </Link>

          {/* 관리 섹션 */}
          <div style={{
            ...sidebarStyles.sectionTitle,
          }}>관리</div>
          
          <Link to="/manage" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/manage" ? sidebarStyles.menuItemActive : {})
              }}
            >
              회원 관리
              <NBadge show={shouldShowBadge("member")} />
            </div>
          </Link>

          {localStorage.getItem("admin_role") === "super_admin" && (
            <Link to="/admin-manage" style={{ textDecoration: 'none' }}>
              <div 
                className="menu-item"
                style={{
                  ...sidebarStyles.menuItem,
                  ...(path === "/admin-manage" ? sidebarStyles.menuItemActive : {})
                }}
              >
                관리자 계정 관리
              </div>
            </Link>
          )}

          <Link to="/inquiry" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/inquiry" ? sidebarStyles.menuItemActive : {})
              }}
            >
              문의 사항 관리
              <NBadge show={shouldShowBadge("inquiry")} />
            </div>
          </Link>

          <Link to="/cs-review" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/cs-review" ? sidebarStyles.menuItemActive : {})
              }}
            >
              고객 후기 관리
              <NBadge show={shouldShowBadge("cs_review")} />
            </div>
          </Link>

          <Link to="/notice" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/notice" ? sidebarStyles.menuItemActive : {})
              }}
            >
              공지 사항 관리
            </div>
          </Link>

          <Link to="/blog" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.startsWith("/blog") ? sidebarStyles.menuItemActive : {})
              }}
            >
              블로그 관리
            </div>
          </Link>

          <Link to="/faq" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/faq" ? sidebarStyles.menuItemActive : {})
              }}
            >
              자주 묻는 질문
            </div>
          </Link>

          <Link to="/popup" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/popup" ? sidebarStyles.menuItemActive : {})
              }}
            >
              팝업 관리
            </div>
          </Link>

          <Link to="/coupon" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/coupon" ? sidebarStyles.menuItemActive : {})
              }}
            >
              쿠폰 관리
            </div>
          </Link>

          <Link to="/fileList" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/fileList" ? sidebarStyles.menuItemActive : {})
              }}
            >
              파일 관리
            </div>
          </Link>

          <Link to="/work-memo" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/work-memo") ? sidebarStyles.menuItemActive : {})
              }}
            >
              업무 메모
            </div>
          </Link>

          {/* 출원 관리 섹션 */}
          <div style={{
            ...sidebarStyles.sectionTitle,
          }}>출원 관리</div>

          <Link to="/self-application" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/self-application") ? sidebarStyles.menuItemActive : {})
              }}
            >
              셀프 출원 관리
              <NBadge show={shouldShowBadge("self_application")} />
            </div>
          </Link>

          <Link to="/agencies" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/agencies") ? sidebarStyles.menuItemActive : {})
              }}
            >
              등록 대행 관리
              <NBadge show={shouldShowBadge("agencies")} />
            </div>
          </Link>

          <Link to="/patent-design" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/patent-design") ? sidebarStyles.menuItemActive : {})
              }}
            >
              특허·디자인 신청
              <NBadge show={shouldShowBadge("patent_design")} />
            </div>
          </Link>

          <Link to="/application-info" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/application-info") ? sidebarStyles.menuItemActive : {})
              }}
            >
              출원 정보 관리
              <NBadge show={shouldShowBadge("application_info")} />
            </div>
          </Link>

          <Link to="/review-self" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/review-self") ? sidebarStyles.menuItemActive : {})
              }}
            >
              검토 요청 관리
              <NBadge show={shouldShowBadge("review_self")} />
            </div>
          </Link>

          {/* 기록 섹션 */}
          <div style={{
            ...sidebarStyles.sectionTitle,
          }}>기록</div>

          <Link to="/bandname" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/bandname" ? sidebarStyles.menuItemActive : {})
              }}
            >
              브랜드 네이밍
              <NBadge show={shouldShowBadge("bandname")} />
            </div>
          </Link>

          <Link to="/possibility-infringement" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/possibility-infringement" ? sidebarStyles.menuItemActive : {})
              }}
            >
              상표 등록 가능성
              <NBadge show={shouldShowBadge("possibility")} />
            </div>
          </Link>

          <Link to="/payments-history" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/payments-history" ? sidebarStyles.menuItemActive : {})
              }}
            >
              결제 내역
              <NBadge show={shouldShowBadge("payments")} />
            </div>
          </Link>

          <Link to="/sales-dashboard" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/sales-dashboard" ? sidebarStyles.menuItemActive : {})
              }}
            >
              매출 관리
            </div>
          </Link>

          <Link to="/statistics" style={{ textDecoration: 'none' }}>
            <div
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/statistics" ? sidebarStyles.menuItemActive : {})
              }}
            >
              통계
            </div>
          </Link>

          <Link to="/analytics" style={{ textDecoration: 'none' }}>
            <div className="menu-item" style={{ ...sidebarStyles.menuItem, ...(path === "/analytics" ? sidebarStyles.menuItemActive : {}) }}>유입·전환율 분석</div>
          </Link>

          {/* 바로가기 섹션 */}
          <div style={{
            ...sidebarStyles.sectionTitle,
          }}>바로가기</div>

          <a
            href="https://markpick.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            style={{ ...sidebarStyles.menuItem, textDecoration: 'none' }}
          >
            마크픽
          </a>

          <a
            href="https://www.markview.co.kr/"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            style={{ ...sidebarStyles.menuItem, textDecoration: 'none' }}
          >
            마크뷰
          </a>

          <a
            href="https://www.kipris.or.kr/khome/main.do"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            style={{ ...sidebarStyles.menuItem, textDecoration: 'none' }}
          >
            키프리스
          </a>

          {/* 베타 섹션 */}
          <div style={{
            ...sidebarStyles.sectionTitle,
          }}>베타</div>

          <Link to="/make-image" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path === "/make-image" ? sidebarStyles.menuItemActive : {})
              }}
            >
              복합 상표 생성기
            </div>
          </Link>

          <Link to="/application-calculator" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/application-calculator") ? sidebarStyles.menuItemActive : {})
              }}
            >
              출원 비용 계산기
            </div>
          </Link>

          <a
            href="https://www.remove.bg/ko/upload"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            style={{ ...sidebarStyles.menuItem, textDecoration: 'none' }}
          >
            도장 누끼
          </a>

          <Link to="/rect-stamp" style={{ textDecoration: 'none' }}>
            <div 
              className="menu-item"
              style={{
                ...sidebarStyles.menuItem,
                ...(path.includes("/rect-stamp") ? sidebarStyles.menuItemActive : {})
              }}
            >
              도장 생성
            </div>
          </Link>
        </div>

        {/* 로그아웃 버튼 */}
        <div style={sidebarStyles.logoutSection}>
          <button
            className="logout-btn"
            style={sidebarStyles.logoutBtn}
            onClick={() => {
              removeCookie("pickAdminMyToken");
              removeCookie("pickAdminRfToken");
              localStorage.clear();
              return navigate("/");
            }}
          >
            로그아웃
          </button>
        </div>

        {emailModal && <EmailSendModal setEmailModal={setEmailModal} />}
      </div>
    </>
  );
};

export default SideBar;